import { SidebarProvider } from '@predoc/cow';
import { AppSidebar } from '@/feature/layout/Sidebar';
import { Outlet } from 'react-router';

export const Layout = () => {
  return (
    <SidebarProvider defaultOpen={false}>
      <AppSidebar />
      <main className="h-screen flex-1 overflow-auto">
        <Outlet />
      </main>
    </SidebarProvider>
  );
};
